export const btnHomeEl = document.querySelector('.js-btn-home');
export const btnMyLibraryEl = document.querySelector('.js-btn-mylibrary');
export const formSearchEl = document.querySelector('#search-form');
export const btnWatchedEl = document.querySelector('.js-btn-watched');
export const btnQueueEl = document.querySelector('.js-btn-queue');
export const movieListEl = document.querySelector('#movie-list');
export const btnLoadMoreEl = document.querySelector('#btn-load-more');
export const backdropEl = document.querySelector('.js-backdrop');
export const modalCloseEl = document.querySelector('.js-modal-close');
export const modalEl = document.querySelector('#modal');
